var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.1665,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 23.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0737 29.0854V29.0852C32.0737 24.319 35.8979 20.4986 40.6679 20.5H40.6681C45.4346 20.5 49.2577 24.3245 49.2563 29.0926V29.0928C49.2563 33.8574 45.4306 37.6795 40.6605 37.6795C35.8956 37.6795 32.0723 33.8537 32.0737 29.0854Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5411 40.0136C36.9521 41.782 36.3919 43.4625 35.8318 45.1429C35.0865 47.3819 34.3654 49.6301 33.5821 51.8555C33.2421 52.8239 33.4577 53.5647 34.1696 54.2615C35.9274 55.9844 37.661 57.7331 39.4021 59.4728C39.5433 59.6139 39.6754 59.7642 39.894 59.998C39.601 59.998 39.4203 59.998 39.2397 59.998C34.3351 59.998 29.4289 59.998 24.5242 59.998C23.199 59.998 22.4689 59.2891 22.4841 57.9806C22.5038 56.2592 22.4082 54.5211 22.6131 52.8209C23.2142 47.8328 25.8267 44.138 30.2 41.7092C32.4421 40.4659 34.8755 39.9179 37.5411 40.0136Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7983 39.9886C48.3492 39.9613 52.1139 41.5218 55.1028 44.8174C57.606 47.5771 58.8447 50.856 58.8507 54.5902C58.8523 55.8016 58.8614 57.013 58.8462 58.2243C58.834 59.2125 58.0644 59.9928 57.0762 59.9958C51.9454 60.0034 46.8145 59.9989 41.6837 59.9973C41.6488 59.9973 41.6124 59.9806 41.4849 59.9503C41.6488 59.7788 41.7794 59.6361 41.9175 59.4994C43.6708 57.7462 45.4165 55.9838 47.1819 54.2426C47.8741 53.561 48.0775 52.8278 47.7542 51.8821C46.4882 48.1676 45.2601 44.4394 44.0199 40.7142C43.9516 40.5032 43.8909 40.2892 43.7983 39.9886Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6696 55.6319C39.566 54.5283 38.5064 53.4779 37.462 52.4107C37.3725 52.3196 37.3284 52.101 37.3694 51.9766C38.429 48.769 39.5037 45.5676 40.577 42.3646C40.5861 42.3373 40.6271 42.3191 40.6984 42.2568C40.7637 42.4208 40.8305 42.5665 40.8806 42.7153C41.8946 45.7391 42.904 48.7645 43.9272 51.7853C44.038 52.1117 43.9955 52.3227 43.7389 52.5701C42.7204 53.5598 41.7261 54.5739 40.6696 55.6319Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhd);
export default __webpack_public_path__ + "static/media/phd.b9438de7de0c1088834fd49c9affc215.svg";
export { ForwardRef as ReactComponent };